import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, SettingsIcon, KeyIcon, BookOpenIcon, PhoneIcon } from 'lucide-react';
import Button from './Button';
import { Link, useLocation } from 'react-router-dom';
import APIKeySettings from './APIKeySettings';
import Wizard from './Wizard';
import { useTranslation } from '../i18n/useTranslation';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAPISettingsOpen, setIsAPISettingsOpen] = useState(false);
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const location = useLocation();
  const {
    t
  } = useTranslation();
  // Check if we're on the home page
  const isHomePage = location.pathname === '/';
  // Create base URL for navigation links
  const baseUrl = isHomePage ? '' : '/';
  // Listen for the custom event to open API settings
  useEffect(() => {
    const handleOpenAPISettings = () => {
      setIsAPISettingsOpen(true);
    };
    window.addEventListener('open-api-settings', handleOpenAPISettings);
    return () => {
      window.removeEventListener('open-api-settings', handleOpenAPISettings);
    };
  }, []);
  return <nav className="border-b border-gray-200 bg-white sticky top-0 z-50 shadow-sm" data-id="element-1941">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1942">
        <div className="flex justify-between h-16 items-center" data-id="element-1943">
          <div className="flex flex-col items-center" data-id="element-1944">
            <Link to="/" data-id="element-1945">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rhREvAJ4b5296S85upFAnM/logonew.png" alt="Shopilots Logo" className="h-8 w-auto" data-id="element-1946" />
              <div className="text-sm font-bold text-purple-300" data-id="element-1947">Shopilots</div>
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-8" data-id="element-1948">
            <a href={`${baseUrl}#solutions`} className="text-dark hover:text-primary transition-colors" data-id="element-1949">
              {t('nav.solutions')}
            </a>
            <a href={`${baseUrl}#platforms`} className="text-dark hover:text-primary transition-colors" data-id="element-1950">
              {t('nav.products')}
            </a>
            <a href={`${baseUrl}#pricing`} className="text-dark hover:text-primary transition-colors" data-id="element-1951">
              {t('nav.pricing')}
            </a>
            <Link to="/gpt-store" className="text-dark hover:text-primary transition-colors" data-id="element-1952">
              {t('nav.gptStore')}
            </Link>
            <Link to="/blog" className="text-dark hover:text-primary transition-colors flex items-center" data-id="element-1953">
              <BookOpenIcon className="h-4 w-4 mr-1" data-id="element-1954" />
              {t('nav.blog')}
            </Link>
            <a href="https://shoppingexpert.ai" target="_blank" rel="noopener noreferrer" className="text-dark hover:text-primary transition-colors" data-id="element-1955">
              {t('nav.shoppingExpert')}
            </a>
            <a href="tel:+19146011670" className="bg-purple-600 text-white hover:bg-purple-700 shadow-md hover:shadow-lg transition-all duration-300 rounded-md px-4 py-2 flex items-center" data-id="element-1956">
              <PhoneIcon className="h-4 w-4 mr-2" data-id="element-1957" />
              (914) 601-1670
            </a>
          </div>
          <div className="md:hidden" data-id="element-1958">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-dark hover:text-primary focus:outline-none" data-id="element-1959">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-1960" /> : <MenuIcon className="h-6 w-6" data-id="element-1961" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white border-b border-gray-200" data-id="element-1962">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-1963">
            <a href={`${baseUrl}#solutions`} className="block px-3 py-2 text-dark hover:text-primary" data-id="element-1964">
              {t('nav.solutions')}
            </a>
            <a href={`${baseUrl}#platforms`} className="block px-3 py-2 text-dark hover:text-primary" data-id="element-1965">
              {t('nav.products')}
            </a>
            <a href={`${baseUrl}#pricing`} className="block px-3 py-2 text-dark hover:text-primary" data-id="element-1966">
              {t('nav.pricing')}
            </a>
            <Link to="/gpt-store" className="block px-3 py-2 text-dark hover:text-primary" data-id="element-1967">
              {t('nav.gptStore')}
            </Link>
            <Link to="/blog" className="block px-3 py-2 text-dark hover:text-primary flex items-center" data-id="element-1968">
              <BookOpenIcon className="h-4 w-4 mr-2" data-id="element-1969" />
              {t('nav.blog')}
            </Link>
            <a href="https://shoppingexpert.ai" target="_blank" rel="noopener noreferrer" className="block px-3 py-2 text-dark hover:text-primary" data-id="element-1970">
              {t('nav.shoppingExpert')}
            </a>
            <a href="tel:+19146011670" className="flex items-center px-3 py-2 text-purple-600 hover:text-purple-700 w-full" data-id="element-1971">
              <PhoneIcon className="h-5 w-5 mr-2" data-id="element-1972" />
              Call (914) 601-1670
            </a>
            <div className="flex flex-col space-y-2 px-3 py-2" data-id="element-1973">
              <a href="tel:+19146011670" className="bg-purple-600 text-white hover:bg-purple-700 shadow-md rounded-md px-4 py-2 text-center" data-id="element-1974">
                <PhoneIcon className="h-4 w-4 inline-block mr-2" data-id="element-1975" />
                Call (914) 601-1670
              </a>
            </div>
          </div>
        </div>}
      {/* Wizard Modal */}
      <Wizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-1976" />
    </nav>;
};
export default Navbar;